﻿import $ = require('jquery');

function createCookie(name: string, value: string, days: number) {
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		var expires = "; expires=" + date.toUTCString();
	}
	else expires = "";
	document.cookie = name + "=" + value + expires + "; path=/";
}

export function initCookieConsent() {
	var acceptCookiesContainer = $("#cookieConsentContainer");
	acceptCookiesContainer.addClass('show');
	$("#acceptCookies").click(function () {
		createCookie("CONSENT", '1', 365);
		acceptCookiesContainer.remove();
	});
}